// ----------------------------------------------------------------------

export default function BusinessComponentsOverride(theme) {
  return {
    MuiUserTableRow: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
          '&.selected': {
            backgroundColor: theme.palette.action.selected,
          },
        },
      },
    },
    MuiTransactionItem: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          transition: theme.transitions.create(['background-color']),
          '&:hover': {
            backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900],
          },
          padding: theme.spacing(1.5, 2),
          marginBottom: theme.spacing(2),
        },
        colorDot: {
          width: 10,
          height: 10,
          borderRadius: '50%',
          marginRight: theme.spacing(1.5),
          flexShrink: 0,
        },
        description: {
          fontWeight: theme.typography.fontWeightMedium,
          marginBottom: theme.spacing(0.5),
          color: theme.palette.text.primary,
        },
        transactionLink: {
          color: 'inherit',
          transition: theme.transitions.create('color'),
          '&:hover': {
            textDecoration: 'underline',
          },
        },
        date: {
          color: theme.palette.text.secondary,
          fontSize: theme.typography.body2.fontSize,
        },
        transactionId: {
          color: theme.palette.text.secondary,
          fontSize: theme.typography.body2.fontSize,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      },
    },
    MuiConsumptionRequest: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          border: `1px solid ${theme.palette.divider}`,
          padding: theme.spacing(2),
          marginBottom: theme.spacing(2),
          transition: theme.transitions.create(['box-shadow']),
          '&:hover': {
            boxShadow: theme.shadows[2],
          },
        },
        header: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: theme.spacing(1.5),
        },
        status: {
          fontWeight: theme.typography.fontWeightMedium,
        },
        transactionDetails: {
          marginBottom: theme.spacing(2),
        },
        actionButtons: {
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: theme.spacing(2),
          '& > button': {
            marginLeft: theme.spacing(1),
          },
        },
      },
    },
    MuiUserDetail: {
      styleOverrides: {
        root: {
          // Ensure the user detail page has consistent spacing
          '& .MuiCard-root': {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          },
          '& .MuiCardContent-root': {
            flex: 1,
          },
        },
        header: {
          padding: theme.spacing(3),
          backgroundColor: theme.palette.mode === 'light' ? theme.palette.primary.lighter : theme.palette.primary.dark,
          color: theme.palette.mode === 'light' ? theme.palette.primary.darker : theme.palette.common.white,
        },
        statBox: {
          padding: theme.spacing(2),
          backgroundColor: theme.palette.background.neutral,
          borderRadius: theme.shape.borderRadius,
          textAlign: 'center',
          height: '100%',
        },
        statValue: {
          fontSize: '1.5rem',
          fontWeight: theme.typography.fontWeightBold,
          color: theme.palette.text.primary,
        },
        statLabel: {
          fontSize: '0.875rem',
          color: theme.palette.text.secondary,
        },
      },
    },
    MuiDataDisplay: {
      styleOverrides: {
        root: {
          marginBottom: theme.spacing(3),
        },
        title: {
          display: 'flex',
          alignItems: 'center',
          marginBottom: theme.spacing(2),
          '& .MuiSvgIcon-root': {
            marginRight: theme.spacing(1),
            color: theme.palette.primary.main,
          },
        },
        content: {
          backgroundColor: theme.palette.background.paper,
          borderRadius: theme.shape.borderRadius,
          padding: theme.spacing(2),
          border: `1px solid ${theme.palette.divider}`,
        },
        labelText: {
          color: theme.palette.text.secondary,
          fontWeight: theme.typography.fontWeightMedium,
        },
        valueText: {
          color: theme.palette.text.primary,
        },
      },
    },
    MuiStatusLabel: {
      styleOverrides: {
        root: {
          display: 'inline-flex',
          alignItems: 'center',
          padding: theme.spacing(0.5, 1),
          borderRadius: theme.shape.borderRadius,
          fontSize: '0.75rem',
          fontWeight: theme.typography.fontWeightMedium,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        },
      },
      variants: [
        {
          props: { variant: 'filled', color: 'default' },
          style: {
            backgroundColor: theme.palette.grey[500_16],
            color: theme.palette.text.primary,
          },
        },
        {
          props: { variant: 'filled', color: 'primary' },
          style: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          },
        },
        {
          props: { variant: 'filled', color: 'secondary' },
          style: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
          },
        },
        {
          props: { variant: 'filled', color: 'info' },
          style: {
            backgroundColor: theme.palette.info.main,
            color: theme.palette.info.contrastText,
          },
        },
        {
          props: { variant: 'filled', color: 'success' },
          style: {
            backgroundColor: theme.palette.success.main,
            color: theme.palette.success.contrastText,
          },
        },
        {
          props: { variant: 'filled', color: 'warning' },
          style: {
            backgroundColor: theme.palette.warning.main,
            color: theme.palette.warning.contrastText,
          },
        },
        {
          props: { variant: 'filled', color: 'error' },
          style: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
          },
        },
      ],
    },
  };
}
